<template lang="pug">
  el-row(:span="24")
    el-col(:span="12")
      app-display(
        label="Área requerida:",
        :content="cadastroOriginal.imovel.area || '-'",
      )
    el-col(:span="12")
      app-display(
        label="VTN:",
        :content="formataVtn(vtn.vtn)",
      )
    el-col(:span="12")
      app-display(
        label="Valor de referência do imóvel:",
        :content="formataVtn(vtn.valRefImovel)",
      )
    el-col(:span="12")
      app-display(
        label="Valor de referência por Ha:",
        :content="formataVtn(vtn.valReHa)",
      )
    el-col(:span="12")
      app-display(
        label="Taxas diversas:",
        :content="formataVtn(vtn.txdiversas)",
      )
</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '@/components/AppDivider'

export default {

  components: {
    AppDisplay,
    AppCollapse,
    AppDivider
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    }
  },
  computed: {
    vtn () {
      return this.cadastroOriginal.vtn
    }
  },
  methods: {
    formataVtn (valor) {
      return (valor && valor !== '0') ? `R$ ${valor}` : 'R$ 0,00'
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {

    div {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesVtn.vue